goog.provide("shadow.js.shim.module$react_use_measure$default");
shadow.js.shim.module$react_use_measure$default = shadow.js.require(198, {})["default"];
